"use client"

import { useAppStore } from "@/app/(store)/appStore"
import { WebPhone } from "@/features/webphone/WebPhone"
import { cn } from "@/lib/utils"
import { Box } from "@mantine/core"
import { notifications } from "@mantine/notifications"
import { useEffect } from "react"

interface WebPhoneContainerProps {
  children?: React.ReactNode | React.ReactNode[]
}

export function WebPhoneContainer({ children }: WebPhoneContainerProps) {
  const {
    webphoneExpanded: expanded,
    webphonePopup: popup,
    webphonePoppedOut: poppedOut,
    setWebphonePoppedOut,
  } = useAppStore()

  useEffect(() => {
    let popupWebphone: Window | null = null
    let popupWebphoneStatusInterval: NodeJS.Timeout | null = null

    function onPopupCloses() {
      setWebphonePoppedOut(false)
      // notifications.show({
      //   title: "Webphone popup closed",
      //   message: "Webphone popup closed",
      //   color: "blue",
      // })
    }

    if (poppedOut) {
      const totalPopupHeight = popup.height + 52 + 250

      popupWebphone = window.open(
        "/webphone?popup=true",
        "Web Phone - Ring.io",
        `width=${popup.width},height=${totalPopupHeight},scrollbars=no,status=no,location=no,toolbar=no,copyhistory=no,menubar=no,popup=true,top=${window.screenTop + window.innerHeight / 2 - totalPopupHeight / 2},left=${window.screenLeft + window.innerWidth / 2 - popup.width / 2}`
      )

      if (!popupWebphone || typeof popupWebphone === "undefined") {
        notifications.show({
          title: "Popups are blocked!",
          message:
            "Your system seems to block popups. Please allow popups for this site to use the webphone as a popup.",
          color: "red",
        })
        setWebphonePoppedOut(false)
      } else {
        popupWebphone?.addEventListener("beforeunload", onPopupCloses)

        popupWebphoneStatusInterval = setInterval(() => {
          if (!popupWebphone || popupWebphone.closed) {
            onPopupCloses()
          }
        }, 1_000)
      }
    }

    return () => {
      if (popupWebphone) {
        popupWebphone.close()
        popupWebphone.removeEventListener("beforeunload", onPopupCloses)

        if (popupWebphoneStatusInterval) {
          clearInterval(popupWebphoneStatusInterval)
        }
      }
    }
  }, [setWebphonePoppedOut, poppedOut, popup.height, popup.width])

  return (
    // <Box
    //   className={cn(
    //     "relative grid size-full grid-rows-1 gap-0",
    //     expanded
    //       ? "grid-cols-1 md:grid-cols-[420px_1fr] lg:grid-cols-[1fr_420px]"
    //       : "grid-cols-1"
    //   )}
    // >
    <div className="relative h-screen w-screen">
      <div
        className={"col-start-1 hidden size-full md:block"}
        style={{
          width: expanded ? "calc(100% - 420px)" : "100%",
        }}
      >
        {children}
      </div>
      <WebPhone
        classNames={{
          root: expanded ? "absolute top-0 right-0 w-[420px]" : "",
        }}
      />
    </div>
    // </Box>
  )
}
